import React from "react";
import { FiClipboard, FiCheck, FiX } from "react-icons/fi";

export default function TimesheetApprovals() {
  const sheets = [
    { name: "Rahul Kumar", hours: "7 hrs", task: "Frontend Development" },
    { name: "Anjali Mehta", hours: "6 hrs", task: "API Integration" },
  ];

  return (
    <div className="p-6">
      <h2 className="text-xl font-semibold mb-4">Timesheet Approvals</h2>

      <div className="bg-white shadow rounded-xl">
        <table className="w-full">
          <thead>
            <tr className="bg-gray-100 border-b">
              <th className="p-3 text-left">Employee</th>
              <th className="p-3 text-left">Hours</th>
              <th className="p-3 text-left">Task</th>
              <th className="p-3 text-left">Action</th>
            </tr>
          </thead>

          <tbody>
            {sheets.map((t, i) => (
              <tr key={i} className="border-b">
                <td className="p-3 flex items-center gap-2"><FiClipboard /> {t.name}</td>
                <td className="p-3">{t.hours}</td>
                <td className="p-3">{t.task}</td>
                <td className="p-3 flex gap-3">
                  <button className="text-green-600 flex items-center gap-1"><FiCheck /> Approve</button>
                  <button className="text-red-600 flex items-center gap-1"><FiX /> Reject</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
